import { render, staticRenderFns } from "./checkManage.vue?vue&type=template&id=d33a8620&"
import script from "./checkManage.vue?vue&type=script&lang=js&"
export * from "./checkManage.vue?vue&type=script&lang=js&"
import style0 from "./checkManage.vue?vue&type=style&index=0&id=d33a8620&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports